import { createSlice } from '@reduxjs/toolkit';

// Utility function
const formatPeriod = (date) => {
  const date1 = new Date(date[0]);
  const date2 = new Date(date[1]);
  const dateOne = `${date1.toLocaleString('default', { month: 'long' })} ${date1.getDate()}, ${date1.getFullYear()}`;
  const dateTwo = `${date2.toLocaleString('default', { month: 'long' })} ${date2.getDate()}, ${date2.getFullYear()}`;

  return `${dateOne} To ${dateTwo}`;
};

const initialState = {
  periodOneDate: null,
  periodTwoDate: null,
  isBothSpecificPeriod: false,
  periodOneHeading: '',
  periodTwoHeading: ''
};

const periodSlice = createSlice({
  name: 'period',
  initialState,
  reducers: {
    setPeriodOneDate: (state, action) => {
      state.periodOneDate = action.payload;
    },
    setPeriodTwoDate: (state, action) => {
      state.periodTwoDate = action.payload;
    },
    setIsBothSpecificPeriod: (state, action) => {
      state.isBothSpecificPeriod = action.payload;
    },
    setPeriodOneHeading: (state, action) => {
      state.periodOneHeading = action.payload;
    },
    setPeriodTwoHeading: (state, action) => {
      state.periodTwoHeading = action.payload;
    },
    updatePeriodState: (state, action) => {
      const { report } = action.payload;
      if (report?.header?.periodType && report?.header?.periodType.length > 1) {
        state.periodOneDate = report?.header?.period[0];
        state.periodTwoDate = report?.header?.period[1];
        let dateOne, dateTwo;
        if (report.header.periodType[0].includes("To") && report.header.periodType[1].includes("To")) {
          dateOne = report.header.periodType[0].split("To");
          dateTwo = report.header.periodType[1].split("To");
          state.periodOneDate = formatPeriod(dateOne);
          state.periodTwoDate = formatPeriod(dateTwo);
          state.isBothSpecificPeriod = false;
        } else if (report.header.periodType[0].includes("To") && !report.header.periodType[1].includes("To")) {
          dateOne = report.header.periodType[0].split("To");
          state.periodOneDate = formatPeriod(dateOne);
          state.periodTwoDate = report.header.period[1];
          state.isBothSpecificPeriod = false;
        } else if (!report.header.periodType[0].includes("To") && report.header.periodType[1].includes("To")) {
          dateTwo = report.header.periodType[1].split("To");
          state.periodOneDate = report.header.period[0];
          state.periodTwoDate = formatPeriod(dateTwo);
          state.isBothSpecificPeriod = false;
        } else {
          state.isBothSpecificPeriod = true;
        }
      } else if (report?.header?.periodType && report?.header?.periodType.length === 1) {
        state.periodOneDate = report?.header?.period[0];
        if (report.header.periodType[0].includes("To")) {
          const dateOne = report.header.periodType[0].split("To");
          state.periodOneDate = formatPeriod(dateOne);
          state.isBothSpecificPeriod = false;
        }
      }
    },
    updatePeriodHeadings: (state, action) => {
      const { exel } = action.payload;
      let periodOneDuration, periodTwoDuration;
      if (exel?.header?.periodType && exel.header.periodType.length > 1) {
        periodOneDuration = exel.header.periodType[0].split(" ")[0];
        periodTwoDuration = exel.header.periodType[1].split(" ")[0];
      } else if (exel?.header?.periodType && exel.header.periodType.length === 1) {
        periodOneDuration = exel.header.periodType[0].split(" ")[0];
      }
      if (!exel?.header?.periodType) {
        state.periodOneHeading = "As At";
      } else if (periodOneDuration === periodTwoDuration) {
        if (periodOneDuration === "YE") {
          state.periodOneHeading = "Year Ended";
          state.periodTwoHeading = "Year Ended";
        } else if (periodOneDuration === "HYE") {
          state.periodOneHeading = "Six Months Ended";
          state.periodTwoHeading = "Six Months Ended";
        } else if (periodOneDuration === "QE") {
          state.periodOneHeading = "Three Months Ended";
          state.periodTwoHeading = "Three Months Ended";
        }
      } else {
        if (periodOneDuration === "YE") {
          state.periodOneHeading = "Year Ended";
        } else if (periodOneDuration === "HYE") {
          state.periodOneHeading = "Six Months Ended";
        } else if (periodOneDuration === "QE") {
          state.periodOneHeading = "Three Months Ended";
        }
        if (periodTwoDuration === "YE") {
          state.periodTwoHeading = "Year Ended";
        } else if (periodTwoDuration === "HYE") {
          state.periodTwoHeading = "Six Months Ended";
        } else if (periodTwoDuration === "QE") {
          state.periodTwoHeading = "Three Months Ended";
        }
      }
    }
  }
});

export const {
  setPeriodOneDate,
  setPeriodTwoDate,
  setIsBothSpecificPeriod,
  setPeriodOneHeading,
  setPeriodTwoHeading,
  updatePeriodState,
  updatePeriodHeadings
} = periodSlice.actions;

export default periodSlice;
